import Vue from 'vue'
import { VTooltip } from 'v-tooltip'
Vue.directive('currency', {
  bind (el, binding, vnode) {
    el.value = binding.value && Number(binding.value).toLocaleString('es-ES', { style: 'currency', currency: !binding.arg ? 'EUR' : binding.arg })
    el.onblur = function (e) {
      if (isNaN(e.target.value) || e.target.value.length === 0) {
        return
      }
      e.target.value = Number(e.target.value).toLocaleString('es-ES', { style: 'currency', currency: !binding.arg ? 'EUR' : binding.arg })
    }

    el.onfocus = function (e) {
      if (isNaN(e.target.value)) {
        return
      }
      e.target.value =
        e.target.value && Number(e.target.value.replace(/[^\d.]/g, ''))
    }
    el.oninput = function (e) {
      vnode.context.$data[binding.expression] = e.target.value
    }
  }
})
Vue.directive('focus-input', function (el, binding, vnode) {
  el.addEventListener('click', () => {
    const inputToFocus = el.getElementsByTagName('input')
    if (inputToFocus.length > 0) {
      inputToFocus[0].focus()
    } else {
      const textareaToFocus = el.getElementsByTagName('textarea')
      if (textareaToFocus.length > 0) {
        textareaToFocus[0].focus()
      }
    }
  })
})

Vue.directive('tooltip', VTooltip)

Vue.directive('autofocus', {
  inserted: (el) => {
    setTimeout(() => {
      el.focus()
    }, 300)
  }
})
